import { render } from "./BirdsEyeDetailPage.vue?vue&type=template&id=23d2b1dd&scoped=true"
import script from "./BirdsEyeDetailPage.vue?vue&type=script&lang=js"
export * from "./BirdsEyeDetailPage.vue?vue&type=script&lang=js"

import "./BirdsEyeDetailPage.vue?vue&type=style&index=0&id=23d2b1dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d2b1dd"]])

export default __exports__